/* Behaviour for the bunie-* sections: rails, tabs, countdowns, scroll reveal.
   Delegated from document, so sections added in the editor work without a re-bind. */
(function () {
  function railStep(rail) {
    var first = rail.firstElementChild;
    return first ? first.getBoundingClientRect().width + 12 : Math.round(rail.clientWidth * 0.8);
  }

  function syncProgress(rail) {
    var wrap = rail.closest('[data-bunie-carousel]');
    var bar = wrap && wrap.querySelector('.bunie-progress__bar');
    if (!bar) return;
    var max = rail.scrollWidth - rail.clientWidth;
    var w = Math.max(12, (rail.clientWidth / rail.scrollWidth) * 100);
    var pct = max > 0 ? rail.scrollLeft / max : 0;
    bar.style.width = w + '%';
    bar.style.left = pct * (100 - w) + '%';
    var prev = wrap.querySelector('[data-bunie-nav="prev"]');
    var next = wrap.querySelector('[data-bunie-nav="next"]');
    if (prev) prev.disabled = rail.scrollLeft <= 1;
    if (next) next.disabled = rail.scrollLeft >= max - 1;
  }

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-bunie-nav]');
    if (nav) {
      var wrap = nav.closest('[data-bunie-carousel]');
      var rail = wrap && wrap.querySelector('[data-bunie-rail]');
      if (!rail) return;
      rail.scrollBy({ left: nav.dataset.bunieNav === 'next' ? railStep(rail) : -railStep(rail), behavior: 'smooth' });
      return;
    }
    var tab = e.target.closest('[data-bunie-tab]');
    if (tab) {
      var root = tab.closest('[data-bunie-tabs]');
      if (!root) return;
      root.querySelectorAll('[data-bunie-tab]').forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      root.querySelectorAll('[data-bunie-panel]').forEach(function (p) {
        p.hidden = p.dataset.buniePanel !== tab.dataset.bunieTab;
      });
      var active = root.querySelector('[data-bunie-panel]:not([hidden]) [data-bunie-rail]');
      if (active) syncProgress(active);
    }
  });

  document.addEventListener('scroll', function (e) {
    var rail = e.target;
    if (rail && rail.nodeType === 1 && rail.hasAttribute && rail.hasAttribute('data-bunie-rail')) syncProgress(rail);
  }, true);

  function initRails() {
    document.querySelectorAll('[data-bunie-rail]').forEach(syncProgress);
  }

  function paintCountdown(el, left) {
    var d = Math.floor(left / 86400000);
    var h = Math.floor((left % 86400000) / 3600000);
    var m = Math.floor((left % 3600000) / 60000);
    var s = Math.floor((left % 60000) / 1000);
    var vals = { days: d, hours: h, minutes: m, seconds: s };
    el.querySelectorAll('[data-unit]').forEach(function (c) {
      var v = vals[c.dataset.unit];
      c.textContent = v < 10 ? '0' + v : String(v);
    });
  }

  function tick() {
    document.querySelectorAll('[data-bunie-countdown]').forEach(function (el) {
      var end = Date.parse(el.dataset.bunieCountdown);
      if (isNaN(end)) return;
      paintCountdown(el, Math.max(0, end - Date.now()));
    });
    document.querySelectorAll('[data-bunie-countdown-loop]').forEach(function (el) {
      var durationMs = parseFloat(el.dataset.bunieCountdownLoop) * 1000;
      if (!durationMs) return;
      var elapsed = Date.now() % durationMs;
      paintCountdown(el, durationMs - elapsed);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initRails(); tick(); });
  document.addEventListener('shopify:section:load', initRails);
  window.addEventListener('resize', initRails);
  setInterval(tick, 1000);
  if (document.readyState !== 'loading') { initRails(); tick(); }

  /* Scroll reveal: fade + rise elements into place as they enter the viewport.
     Applies broadly via a shared selector list rather than per-section markup,
     so every bunie-* section gets it for free. Respects reduced-motion.

     Singleton observer (module-level, created once) rather than one per
     initReveal() call — initReveal legitimately runs more than once (initial
     load, shopify:section:load, resize), and re-creating the observer each
     time risks orphaned instances competing over the same elements.

     Safety net: if IntersectionObserver never fires for some element (a stale
     layout read, a section injected after load, any edge case) that element
     force-reveals after 2.5s instead of staying invisible forever — a missed
     entrance animation is a cosmetic miss, permanently hidden content is not. */
  var REVEAL_SELECTOR = [
    '.bhero__card', '.bcirc__item', '.bfeat__inner', '.bcol__card', '.bcard',
    '.bsw__panel', '.bsw__card', '.bcc__card', '.bnum__item', '.bst__row',
    '.bts__card', '.bcd__card', '.bcd__row', '.bwc__item', '.bnl__panel', '.big__item'
  ].join(',');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealIO = null;

  function revealNow(el) {
    if (el.classList.contains('bunie-in-view')) return;
    el.classList.add('bunie-in-view');
  }

  function initReveal() {
    if (reduceMotion) return;
    var els = document.querySelectorAll(REVEAL_SELECTOR);
    if (!els.length) return;

    if (!revealIO && 'IntersectionObserver' in window) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealNow(entry.target);
          revealIO.unobserve(entry.target);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    }

    els.forEach(function (el, i) {
      if (el.classList.contains('bunie-reveal') || el.classList.contains('bunie-in-view')) return;
      var col = Array.prototype.indexOf.call(el.parentElement ? el.parentElement.children : [], el);
      el.style.transitionDelay = (Math.min(col, 5) * 70) + 'ms';
      el.classList.add('bunie-reveal');
      if (revealIO) {
        revealIO.observe(el);
        setTimeout(function () { revealNow(el); }, 2500);
      } else {
        revealNow(el);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initReveal);
  document.addEventListener('shopify:section:load', initReveal);
  if (document.readyState !== 'loading') initReveal();
})();
